import {
  buttonLinkSchema,
  buttonLinkUrlSchema,
} from "../components/Button.sanity";
import { linkUrlGroq } from "../sanity/schemas/link";

export const ctaSectionSchema = {
  type: "object",
  name: "ctaSection",
  title: "CTA Section",
  description: "Leave empty to hide the section",
  options: {
    collapsible: true,
    collapsed: false,
  },
  fields: [
    {
      name: "title",
      title: "Title",
      type: "string",
    },
    {
      name: "text",
      type: "text",
      rows: 3,
    },
    buttonLinkUrlSchema,
  ],
};

export const ctaSectionGroq = `
  title,
  text,
  "button": button{
    label,
    "url": ${linkUrlGroq}
  }
`;
